export function getApiBaseUrl() {
  const { protocol, hostname, port } = window.location;

  if (hostname === "wedding.mupende.com") {
    return "";
  }

  if (port === "3553") {
    return `${protocol}//${hostname}:8893`;
  }

  if (port === "3000" || port === "5173") {
    return `${protocol}//${hostname}:8893`;
  }

  return "";
}

export function apiUrl(path) {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${path}`;
}

export function wsUrl(path) {
  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) {
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${window.location.host}${path}`;
  }

  const wsBaseUrl = apiBaseUrl.replace(/^http:/, "ws:").replace(/^https:/, "wss:");
  return `${wsBaseUrl}${path}`;
}
